(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function() {
  var FREE_SHIP_THRESHOLD = 5000;
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var backdrop = drawer.querySelector('.cd__backdrop');
  var countEl = drawer.querySelector('[data-cd-count]');
  var itemsEl = drawer.querySelector('[data-cd-items]');
  var emptyEl = drawer.querySelector('[data-cd-empty]');
  var footerEl = drawer.querySelector('[data-cd-footer]');
  var subtotalEl = drawer.querySelector('[data-cd-subtotal]');
  var shipBar = drawer.querySelector('[data-cd-ship]');
  var shipMsg = drawer.querySelector('[data-cd-ship-msg]');
  var shipFill = drawer.querySelector('[data-cd-ship-fill]');
  var shipTrack = drawer.querySelector('[data-cd-ship-track]');
  var lastFocused = null;
  var fetching = false;
  var reqSeq = 0;                    // monotonic id — only the latest change paints the UI
  var writeChain = Promise.resolve(); // serialize cart writes so they apply in click order
  var writeTimers = {};              // key -> debounce timer (collapses rapid clicks into one write)
  var pendingQty = {};               // key -> latest desired quantity

  function fmt(c) { return '$' + (c/100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  function open() {
    lastFocused = document.activeElement;
    drawer.removeAttribute('hidden');
    requestAnimationFrame(function() { drawer.classList.add('is-open'); });
    document.body.classList.add('cd-locked');
    refresh();
    var closeBtn = drawer.querySelector('.cd__close');
    if (closeBtn) closeBtn.focus();
  }
  function close() {
    drawer.classList.remove('is-open');
    document.body.classList.remove('cd-locked');
    setTimeout(function(){ drawer.setAttribute('hidden', ''); }, 320);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function fetchCart() {
    if (fetching) return Promise.resolve(null);
    fetching = true;
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .finally(function(){ fetching = false; });
  }

  function renderItem(item) {
    var img = item.image || item.featured_image && item.featured_image.url || '';
    var imgUrl = img ? (img.indexOf('//') === 0 ? 'https:' + img : img) : '';
    var imgSized = imgUrl ? imgUrl.replace(/(\.(jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_180x180.$2$3') : '';
    var variantLine = (item.variant_title && item.variant_title !== 'Default Title') ? '<div class="cd__item-variant">' + esc(item.variant_title) + '</div>' : '';
    var planLine = '';
    if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
      planLine = '<div class="cd__item-plan">↻ ' + esc(item.selling_plan_allocation.selling_plan.name) + '</div>';
    }
    var compareLine = '';
    if (item.original_line_price && item.final_line_price && item.original_line_price > item.final_line_price) {
      compareLine = '<span class="cd__item-price-compare">' + fmt(item.original_line_price) + '</span>';
    }
    return (
      '<div class="cd__item" data-cd-item data-key="' + esc(item.key) + '" data-qty="' + item.quantity + '">' +
        '<a href="' + esc(item.url) + '" class="cd__item-img" tabindex="-1" aria-hidden="true">' +
          (imgSized ? '<img src="' + esc(imgSized) + '" alt="" loading="lazy" width="64" height="64">' : '') +
        '</a>' +
        '<div class="cd__item-info">' +
          '<a href="' + esc(item.url) + '" class="cd__item-title">' + esc(item.product_title) + '</a>' +
          variantLine + planLine +
          '<div class="cd__item-bottom">' +
            '<div class="cd__stepper">' +
              '<button type="button" data-cd-decr aria-label="Decrease quantity">−</button>' +
              '<span class="cd__stepper-val" data-cd-qty>' + item.quantity + '</span>' +
              '<button type="button" data-cd-incr aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<div class="cd__item-price">' + fmt(item.final_line_price) + compareLine + '</div>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="cd__item-remove" data-cd-remove aria-label="Remove ' + esc(item.product_title) + '">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M6 18L18 6"/></svg>' +
        '</button>' +
      '</div>'
    );
  }

  function syncHeaderBadge(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function(el) {
      el.textContent = count < 100 ? count : '';
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function render(cart) {
    if (!cart || typeof cart.item_count !== 'number') return; // ignore error responses (e.g. Cart Error)
    var count = cart.item_count || 0;
    countEl.textContent = count;
    syncHeaderBadge(count);

    if (count === 0) {
      itemsEl.innerHTML = '';
      emptyEl.hidden = false;
      footerEl.hidden = true;
    } else {
      emptyEl.hidden = true;
      footerEl.hidden = false;
      itemsEl.innerHTML = cart.items.map(renderItem).join('');
      subtotalEl.textContent = fmt(cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price);
    }

    var subtotal = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
    var pct = Math.min(100, (subtotal / FREE_SHIP_THRESHOLD) * 100);
    var hit = subtotal >= FREE_SHIP_THRESHOLD;
    shipFill.style.width = (count === 0 ? 0 : pct) + '%';
    if (hit) {
      shipBar.classList.add('is-hit');
      shipMsg.innerHTML = '🎉 You unlocked <strong>FREE shipping</strong>';
    } else if (count === 0) {
      shipBar.classList.remove('is-hit');
      shipMsg.textContent = 'Add items to unlock FREE shipping';
    } else {
      shipBar.classList.remove('is-hit');
      shipMsg.innerHTML = 'Add <strong>' + fmt(FREE_SHIP_THRESHOLD - subtotal) + '</strong> more for FREE shipping';
    }
    if (shipTrack) {
      shipTrack.setAttribute('aria-valuenow', Math.round(pct));
      shipTrack.setAttribute('aria-valuetext', hit ? 'Free shipping unlocked' : Math.round(pct) + '% to free shipping');
    }
  }

  function refresh() {
    return fetchCart().then(function(cart){ if (cart) render(cart); return cart; });
  }

  function changeLine(key, qty, lineEl) {
    // 1) Optimistic UI right away so rapid clicks feel instant and each click
    //    computes its next target from the latest intent, not a stale value.
    if (lineEl) {
      lineEl.dataset.qty = qty;
      if (qty === 0) {
        lineEl.classList.add('is-removing');
      } else {
        var qEl = lineEl.querySelector('[data-cd-qty]');
        if (qEl) qEl.textContent = qty;
      }
    }
    // 2) Debounce the network write per line: only the FINAL quantity is sent,
    //    as one absolute-quantity request once clicking settles. Firing
    //    back-to-back /cart/change.js calls for the same line makes Shopify
    //    reject the follow-ups mid-write, which left the cart and the shipping
    //    bar out of sync (the bug this fixes).
    pendingQty[key] = qty;
    if (writeTimers[key]) clearTimeout(writeTimers[key]);
    writeTimers[key] = setTimeout(function(){
      delete writeTimers[key];
      var finalQty = pendingQty[key];
      delete pendingQty[key];
      commitWrite(key, finalQty, lineEl);
    }, 300);
  }

  function commitWrite(key, qty, lineEl) {
    var myReq = ++reqSeq;
    // Serialize across lines so multi-item edits apply in order.
    writeChain = writeChain.then(function(){
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function(r){ return r.json(); }).then(function(cart){
        if (myReq !== reqSeq) return;                                  // a newer edit is queued — let it win
        if (!cart || typeof cart.item_count !== 'number') return refresh(); // error response — resync from truth
        render(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
      }).catch(function(err){
        console.error('Cart drawer change error', err);
        if (lineEl) lineEl.classList.remove('is-removing');
        refresh(); // resync to server truth on failure
      });
    });
    return writeChain;
  }

  // Triggers
  document.addEventListener('click', function(e) {
    var openEl = e.target.closest('a[href="/cart"], a[href$="/cart"], [data-cart-drawer-open]');
    if (openEl && !openEl.hasAttribute('data-cd-no-drawer')) {
      e.preventDefault();
      open();
      return;
    }
    if (e.target.closest('[data-cd-close]')) { close(); return; }
    if (drawer.hidden) return;

    var item = e.target.closest('[data-cd-item]');
    if (!item) return;
    var key = item.dataset.key;
    var qtyEl = item.querySelector('[data-cd-qty]');
    var qty = item.dataset.qty != null ? parseInt(item.dataset.qty, 10) : (qtyEl ? parseInt(qtyEl.textContent, 10) : 0);

    if (e.target.closest('[data-cd-incr]')) { changeLine(key, qty + 1, item); }
    else if (e.target.closest('[data-cd-decr]')) { changeLine(key, Math.max(0, qty - 1), item); }
    else if (e.target.closest('[data-cd-remove]')) { changeLine(key, 0, item); }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && !drawer.hidden && drawer.classList.contains('is-open')) close();
  });

  document.addEventListener('cart:updated', function(e) {
    if (e && e.detail && e.detail.cart) { render(e.detail.cart); return; }
    refresh();
  });
  document.addEventListener('cart-drawer:open', function() { open(); });

  // Open when buy box adds is-open class
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      if (m.attributeName === 'class' && drawer.classList.contains('is-open') && drawer.hasAttribute('hidden')) {
        drawer.removeAttribute('hidden');
        document.body.classList.add('cd-locked');
        refresh();
      }
    });
  });
  observer.observe(drawer, { attributes: true });

    // ===== Upsell (product list, live-synced with cart) =====
  var upsellEl = drawer.querySelector('[data-cd-upsell]');
  var upsellListEl = drawer.querySelector('[data-cd-upsell-list]');
  var upsellCfgEl = drawer.querySelector('[data-cd-upsell-config]');
  var upsellCfg = null;
  if (upsellEl && upsellListEl && upsellCfgEl) {
    try { upsellCfg = JSON.parse(upsellCfgEl.textContent); } catch (e) { console.error('Cart drawer upsell config error', e); }
  }

  function renderUpsell(cart) {
    if (!upsellCfg || !upsellCfg.products || !upsellCfg.products.length) { if (upsellEl) upsellEl.hidden = true; return; }
    if (!cart || !cart.items) { upsellEl.hidden = true; return; }

    var cartProductIds = {};
    cart.items.forEach(function(item){ cartProductIds[item.product_id] = true; });

    // Skip any configured product that's already in the cart.
    var eligible = upsellCfg.products.filter(function(p){ return !cartProductIds[p.productId]; });

    if (!eligible.length || cart.item_count === 0) { upsellEl.hidden = true; return; }

    var max = upsellCfg.maxShow || 2;
    var shown = eligible.slice(0, max);

    upsellListEl.innerHTML = shown.map(function(p){
      var priceStr = fmt(p.price);
      return (
        '<div class="cd__upsell-item" data-cd-upsell-item data-variant-id="' + esc(p.variantId) + '">' +
          '<a href="' + esc(p.url) + '" class="cd__upsell-img" tabindex="-1" aria-hidden="true">' +
            (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy" width="48" height="48">' : '') +
          '</a>' +
          '<div class="cd__upsell-info">' +
            '<a href="' + esc(p.url) + '" class="cd__upsell-name">' + esc(p.title) + '</a>' +
            '<span class="cd__upsell-price">' + priceStr + '</span>' +
          '</div>' +
          '<button type="button" class="cd__upsell-add" data-cd-upsell-add' + (p.available ? '' : ' disabled') + '>' +
            (p.available ? 'Add' : 'Sold out') +
          '</button>' +
        '</div>'
      );
    }).join('');

    // "View All" button only makes sense once there's more configured product(s)
    // than we're currently able to show (either because maxShow trimmed the list,
    // or because some were filtered out for already being in the cart).
    var viewAllBtn = upsellEl.querySelector('.cd__upsell-viewall');
    if (viewAllBtn) viewAllBtn.hidden = eligible.length <= shown.length;

    upsellEl.hidden = false;
  }

  function addUpsellItem(variantId, btn) {
    if (!variantId) return;
    var originalText = btn.textContent;
    btn.setAttribute('disabled', '');
    btn.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    }).then(function(r){ if (!r.ok) return r.json().then(function(err){ throw new Error(err.description || 'Cart error'); }); return r.json(); })
      .then(function(){ return refresh(); })
      .then(function(cart){
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
      })
      .catch(function(err){
        console.error('Cart drawer upsell add error', err);
        btn.removeAttribute('disabled');
        btn.textContent = originalText;
      });
  }

  if (upsellEl) {
    upsellEl.addEventListener('click', function(e){
      var addBtn = e.target.closest('[data-cd-upsell-add]');
      if (!addBtn || addBtn.hasAttribute('disabled')) return;
      var item = addBtn.closest('[data-cd-upsell-item]');
      if (!item) return;
      addUpsellItem(item.dataset.variantId, addBtn);
    });
  }

  // Re-render the upsell rail every time the cart's contents change, using
  // the SAME cart payload already flowing through render() — no extra fetch.
  var originalRender = render;
  render = function(cart) { originalRender(cart); renderUpsell(cart); };

  // Pre-fetch on page load to populate the count badge
  refresh();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-buy-box-form"] && !Shopify.designMode) return;
  try {
    (function() {
    /* Move the main product gallery to the selected variant's image when the buy
       box drives the picker. The theme renders the gallery in one of two states:

       (1) Products WITH distinct per-variant image alts: the theme pre-hides every
           non-selected-variant slide at render time (display:none). Here we keep the
           theme's original behavior — fade in the selected variant's image set by
           alt (variant-color) and hide the rest. This is the long-standing behavior
           and must not change for these products.

       (2) Products WITHOUT distinct alts (all slides visible): there is nothing to
           un-hide, so we simply navigate the existing Flickity carousel to the
           variant's slide by media id and hide NOTHING — every image stays
           browsable/scrollable. This is the case that previously didn't swap at all.

       We pick the branch by checking whether the variant's own slide is hidden. */
    function cbbSwapGalleryMedia(mediaId, sectionId) {
      if (mediaId == null || mediaId === '') return;
      var mainSel = '#media-main-' + mediaId;
      var thumbSel = '#media-thumb-' + mediaId;
      var mainCell = document.querySelector(mainSel);
      if (!mainCell) return; // variant has no distinct gallery slide; leave gallery untouched

      var jq = window.jQuery;
      var targetHidden = mainCell.offsetParent === null;

      /* M&S selector mode (cbb--ms): never collapse the gallery. The theme
         pre-hides non-selected-variant slides at render time for products with
         distinct per-variant alts; here we un-hide everything once so every
         image stays browsable, then just navigate to the variant's slide.
         Old templates are untouched — they take the branches below. */
      if (jq && document.querySelector('[data-cbb].cbb--ms')) {
        var msSlider = jq(mainCell).closest('.yv-product-big-slider');
        var msImages = msSlider.find('.yv-product-image-item');
        var msHidden = msImages.filter(function(){ return jq(this).css('display') === 'none'; }).length;
        if (msHidden > 0) {
          var msFancy = 'gallery' + (sectionId || '');
          if (msSlider.hasClass('flickity-enabled') && window.productSlider) window.productSlider.destroy();
          msImages.show();
          msImages.find('a.yv-product-zoom').attr('data-fancybox', msFancy);
          jq('.yv-product-video-item, .yv-product-model-item').show();
          var msThumbWrap = jq('.gallery__slide-img').closest('.data-thumb-slider');
          if (msThumbWrap.hasClass('flickity-enabled') && window.productThumbSlider) window.productThumbSlider.destroy();
          jq('.gallery__slide-img').show();
          if (typeof window.initProductSlider === 'function') window.initProductSlider();
          if (typeof window.initProductThumbSlider === 'function') window.initProductThumbSlider();
        }
        /* flickity-fade loses track of the previously selected slide once all
           cells are visible: on any navigation (our swaps AND the arrows) the
           old cell can stay at opacity 1 alongside the new one and paint on top
           (wrong image shown). Enforce exactly-one-visible on every selection.
           Fade mode only — never touch the mobile flex-scroll gallery, where
           opacity 0 would blank the strip. */
        function msEnforceFade(targetEl){
          document.querySelectorAll('.yv-product-big-slider .yv-product-image-item').forEach(function(c){
            c.style.opacity = (c === targetEl) ? '1' : '0';
          });
        }
        var msFl = window.productSlider;
        if (msFl && msFl.options && msFl.options.fade && typeof msFl.on === 'function' && !msFl._msFadeFix) {
          msFl._msFadeFix = true;
          msFl.on('select', function(){ if (msFl.selectedElement) msEnforceFade(msFl.selectedElement); });
        }
        if (msFl && typeof msFl.selectCell === 'function') {
          try { msFl.selectCell(mainSel, false, true); } catch (e) {}
          if (msFl.options && msFl.options.fade) {
            var msTarget = document.querySelector(mainSel);
            if (msTarget) msEnforceFade(msTarget);
          }
        } else {
          /* no slider running (mobile flex-scroll): move the STRIP, never the
             page — scrollIntoView here scrolled the whole page to the gallery */
          var msWrap = mainCell.closest('.data-main-slider') || mainCell.parentElement;
          if (msWrap) {
            var msDx = mainCell.getBoundingClientRect().left - msWrap.getBoundingClientRect().left;
            try { msWrap.scrollBy({ left: msDx, behavior: 'smooth' }); } catch (e) { msWrap.scrollLeft += msDx; }
          }
        }
        if (document.querySelector(thumbSel) && window.productThumbSlider && typeof window.productThumbSlider.selectCell === 'function') {
          try { window.productThumbSlider.selectCell(thumbSel, false, true); } catch (e) {}
        }
        return;
      }

      if (targetHidden && jq) {
        /* State (1): restore the theme's original alt-based fade swap. */
        var imageAlt = (mainCell.getAttribute('variant-color') || '').toLowerCase();
        if (imageAlt === '') return;
        var fancyGroup = 'gallery' + (sectionId || '');
        var mainSlider = jq('.yv-product-image-item').closest('.yv-product-big-slider');
        var matchImages = mainSlider.find('.yv-product-image-item[variant-color="' + imageAlt + '"]');
        var allImages = mainSlider.find('.yv-product-image-item');
        if (matchImages.length > 0) {
          if (mainSlider.hasClass('flickity-enabled') && window.productSlider) {
            window.productSlider.destroy();
          }
          allImages.hide();
          allImages.find('a.yv-product-zoom').attr('data-fancybox', 'none');
          jq('.yv-product-model-item').hide();
          matchImages.fadeIn('slow');
          matchImages.find('a.yv-product-zoom').attr('data-fancybox', fancyGroup);
          jq('.yv-product-video-item[variant-color="' + imageAlt + '"]').show();
          jq('.yv-product-model-item[variant-color="' + imageAlt + '"]').show();
          if (typeof window.initProductSlider === 'function') window.initProductSlider();
        }
        var thumbWrap = jq('.gallery__slide-img').closest('.data-thumb-slider');
        var matchThumbs = jq('.gallery__slide-img[variant-color="' + imageAlt + '"]');
        if (matchThumbs.length > 0) {
          if (thumbWrap.hasClass('flickity-enabled') && window.productThumbSlider) {
            window.productThumbSlider.destroy();
          }
          jq('.gallery__slide-img').hide();
          matchThumbs.fadeIn('slow');
          if (typeof window.initProductThumbSlider === 'function') window.initProductThumbSlider();
        }
        return;
      }

      /* State (2): all slides visible — navigate, hide nothing.
         Use isInstant=true: this slider runs in Flickity fade mode (fade:true,
         draggable:false), and an animated programmatic select leaves the fade
         half-applied (target stuck near opacity 0). Instant select sets the
         opacity cleanly (target 1, others 0). */
      if (window.productSlider && typeof window.productSlider.selectCell === 'function') {
        try { window.productSlider.selectCell(mainSel, false, true); } catch (e) {}
      } else if (typeof mainCell.scrollIntoView === 'function') {
        mainCell.scrollIntoView({ block: 'nearest', inline: 'center' });
      }
      if (document.querySelector(thumbSel) && window.productThumbSlider && typeof window.productThumbSlider.selectCell === 'function') {
        try { window.productThumbSlider.selectCell(thumbSel, false, true); } catch (e) {}
      }
    }

    document.querySelectorAll('[data-cbb]').forEach(function(root) {
      var configEl = root.querySelector('[data-cbb-config]');
      var sellingPlansEl = root.querySelector('[data-cbb-selling-plans]');
      if (!configEl || !sellingPlansEl) return;
      var config, sellingPlansByProduct;
      try { config = JSON.parse(configEl.textContent); sellingPlansByProduct = JSON.parse(sellingPlansEl.textContent); }
      catch (e) { console.error('CBB parse error', e); return; }

      var products = root.querySelectorAll('[data-product]');
      var heroProduct = root.querySelector('[data-is-hero="true"]');
      var heroAtcBtn = root.querySelector('[data-hero-atc]');
      var totalPriceEl = root.querySelector('[data-total-price]');
      var savingsEl = root.querySelector('[data-savings]');
      var savingsTextEl = root.querySelector('[data-savings-text]');
      var atcBtn = root.querySelector('[data-atc]');
      var atcText = root.querySelector('[data-atc-text]');
      var tiers = root.querySelectorAll('[data-tier]');
      var shippingBar = root.querySelector('[data-shipping-bar]');
      var shippingFill = root.querySelector('[data-shipping-fill]');
      var shippingMsg = root.querySelector('[data-shipping-msg]');
      var shippingTrack = root.querySelector('[data-shipping-track]');
      var tabs = root.querySelectorAll('[data-purchase]');
      var freqSelect = root.querySelector('[data-frequency-select]');
      var freqWrap = root.querySelector('[data-frequency-wrap]');
      var confettiHost = root.querySelector('[data-confetti]');
      var compareEl = root.querySelector('[data-compare]');
      var heroAtcLabelEl = root.querySelector('.cbb__hero-atc-label');
      var heroRecurringEl = root.querySelector('[data-hero-atc-recurring]');
      var heroAtcOriginalLabel = heroAtcLabelEl ? heroAtcLabelEl.textContent : '';
      var packCta = root.querySelector('[data-pack-cta]');
      var pickSection = root.querySelector('.cbb__pick-section');
      var pickMoreBtn = root.querySelector('[data-pick-more]');
      var pickMoreText = root.querySelector('[data-pick-more-text]');
      var toastEl = root.querySelector('[data-toast]');
      var toastTimer = null;
      function showToast(msg) {
        if (!toastEl) return;
        toastEl.textContent = msg;
        toastEl.hidden = false;
        if (toastTimer) clearTimeout(toastTimer);
        toastTimer = setTimeout(function(){ toastEl.hidden = true; }, 4000);
      }

      var tierHintEl = root.querySelector('[data-tier-hint]');
      var state = { purchaseType: 'subscribe', frequency: freqSelect ? freqSelect.value : null, lastShipHit: false };

      function formatMoney(c) { return '$' + (c/100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'); }
      function totalQty() { var t=0; products.forEach(function(p){ t += parseInt(p.dataset.qty||0,10); }); return t; }
      function activeTier(q) { var a=config.tiers[0]; config.tiers.forEach(function(t){ if(q>=t.min) a=t; }); return a; }
      function discountFactor(pct) {
        if (state.purchaseType === 'subscribe') return 1 - ((1 - config.subPct/100) * (1 - pct/100));
        return pct/100;
      }
      function spawnConfetti() {
        if (!confettiHost) return;
        confettiHost.innerHTML = '';
        var cs = getComputedStyle(root);
        var accent = cs.getPropertyValue('--cbb-accent').trim() || '#FF5722';
        var decoy = cs.getPropertyValue('--cbb-decoy').trim() || '#FFD23F';
        var success = cs.getPropertyValue('--cbb-success').trim() || '#2D9D78';
        var colors = [accent, decoy, success, accent];
        for (var i=0; i<12; i++) { var s=document.createElement('span'); s.style.left=(10+Math.random()*80)+'%'; s.style.top='50%'; s.style.background=colors[i%colors.length]; s.style.setProperty('--cx',(Math.random()*80-40)+'px'); s.style.setProperty('--cy',(-30-Math.random()*30)+'px'); confettiHost.appendChild(s); }
      }

      function factorFor(purchaseType, pct) {
        if (purchaseType === 'subscribe') return 1 - ((1 - config.subPct/100) * (1 - pct/100));
        return pct/100;
      }

      function bmsmCompute(unitPrices, pcts, extraSubPct) {
        if (!unitPrices.length) return { disc: 0, raw: 0 };
        var sorted = unitPrices.slice().sort(function(a, b){ return a - b; });
        var raw = 0;
        for (var k = 0; k < sorted.length; k++) raw += sorted[k];
        var maxDiscounts = (pcts && pcts.length > 1) ? pcts.length - 1 : 0;
        var firing = Math.min(sorted.length - 1, maxDiscounts);
        if (firing < 0) firing = 0;
        var subF = (extraSubPct || 0) / 100;
        var total = 0;
        for (var i = 0; i < sorted.length; i++) {
          var pct = (i < firing) ? (pcts[i + 1] || 0) : 0;
          total += sorted[i] * (1 - subF) * (1 - pct / 100);
        }
        return { disc: Math.round(total), raw: raw };
      }

      function recompute() {
        var q = totalQty();
        var tier = activeTier(q);
        var raw, disc, savings, subTotal, oneTimeTotal, subDelta;

        if (config.discountMode === 'bmsm') {
          var unitPrices = [];
          products.forEach(function(p){
            var qq = parseInt(p.dataset.qty||0,10);
            var pp = parseInt(p.dataset.price||0,10);
            for (var k = 0; k < qq; k++) unitPrices.push(pp);
          });
          var subPctNow = state.purchaseType === 'subscribe' ? config.subPct : 0;
          var rNow = bmsmCompute(unitPrices, config.bmsmPcts, subPctNow);
          raw = rNow.raw;
          disc = rNow.disc;
          savings = raw - disc;
          subTotal = bmsmCompute(unitPrices, config.bmsmPcts, config.subPct).disc;
          oneTimeTotal = bmsmCompute(unitPrices, config.bmsmPcts, 0).disc;
          subDelta = oneTimeTotal - subTotal;
        } else {
          var df = discountFactor(tier.pct);
          raw = 0;
          products.forEach(function(p){ var qq=parseInt(p.dataset.qty||0,10); raw += qq * parseInt(p.dataset.price||0,10); });
          disc = Math.round(raw * (1 - df));
          savings = raw - disc;
          subTotal = Math.round(raw * (1 - factorFor('subscribe', tier.pct)));
          oneTimeTotal = Math.round(raw * (1 - factorFor('onetime', tier.pct)));
          subDelta = oneTimeTotal - subTotal;
        }
        if (compareEl) {
          if (q > 0 && subDelta > 0) {
            if (state.purchaseType === 'subscribe') {
              compareEl.innerHTML = 'You save <strong>' + formatMoney(subDelta) + '</strong> vs one-time';
            } else {
              compareEl.innerHTML = 'Subscribe to save <strong>' + formatMoney(subDelta) + '</strong>';
            }
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }

        totalPriceEl.textContent = formatMoney(disc);
        if (savings > 0) { savingsTextEl.textContent = 'You save ' + formatMoney(savings); savingsEl.hidden = false; }
        else { savingsEl.hidden = true; }

        if (heroProduct) {
          var heroPriceNow = heroProduct.querySelector('[data-product-price]');
          var heroPriceWas = heroProduct.querySelector('[data-price-was]');
          var heroPriceTag = heroProduct.querySelector('[data-price-savetag]');
          // The stack shows the TOTAL for the selected quantity — disc/raw/savings are
          // already computed above for the active purchase type (sub + tier stack, and
          // bmsm mode) and, with the in-box picker gone, cover exactly the hero product.
          // Displaying the unit price here was the bug: qty changes left the price static.
          if (heroPriceNow) heroPriceNow.textContent = formatMoney(disc);
          if (savings > 0) {
            if (heroPriceWas) { heroPriceWas.textContent = formatMoney(raw); heroPriceWas.hidden = false; }
            if (heroPriceTag) { heroPriceTag.textContent = 'SAVE ' + Math.round((savings / raw) * 100) + '%'; heroPriceTag.hidden = false; }
          } else {
            if (heroPriceWas) heroPriceWas.hidden = true;
            if (heroPriceTag) heroPriceTag.hidden = true;
          }
          if (heroAtcLabelEl) heroAtcLabelEl.textContent = heroAtcOriginalLabel;
          if (heroRecurringEl) heroRecurringEl.hidden = true;
        }

        tiers.forEach(function(t){ t.classList.toggle('is-active', parseInt(t.dataset.tierMin,10) === tier.min); });

        if (shippingBar) {
          var hit = disc >= config.freeShipThreshold;
          var displayUnlocked = hit && q > 0;
          if (displayUnlocked) {
            shippingFill.style.width = '100%';
            shippingBar.classList.add('is-hit');
            shippingMsg.innerHTML = config.messages.shippingHit;
            if (hit && !state.lastShipHit) spawnConfetti();
          } else if (q === 0) {
            shippingFill.style.width = '0%';
            shippingBar.classList.remove('is-hit');
            shippingMsg.innerHTML = config.messages.shippingDefault;
          } else {
            var pct = Math.min(100, (disc / config.freeShipThreshold) * 100);
            shippingFill.style.width = pct + '%';
            shippingBar.classList.remove('is-hit');
            shippingMsg.innerHTML = config.messages.shippingBelow.replace('{amount}', '<strong>' + formatMoney(config.freeShipThreshold - disc) + '</strong>');
          }
          if (shippingTrack) {
            var ariaPct = displayUnlocked ? 100 : (q === 0 ? 0 : Math.min(100, (disc / config.freeShipThreshold) * 100));
            shippingTrack.setAttribute('aria-valuenow', Math.round(ariaPct));
            shippingTrack.setAttribute('aria-valuetext', displayUnlocked ? 'Free shipping unlocked' : (q === 0 ? 'No items selected' : Math.round(ariaPct) + '% to free shipping, ' + formatMoney(Math.max(0, config.freeShipThreshold - disc)) + ' to go'));
          }
          state.lastShipHit = hit;
        }

        if (tierHintEl) {
          if (config.discountMode === 'bmsm') {
            var ordinals = ['','1st','2nd','3rd','4th','5th'];
            var maxLadder = (config.bmsmPcts && config.bmsmPcts.length) || 0;
            if (q >= 1 && q < maxLadder - 1 + 1 && q < maxLadder) {
              var nextPct = config.bmsmPcts[q] || 0;
              var ord = ordinals[q + 1] || ((q + 1) + 'th');
              tierHintEl.innerHTML = 'Add <strong>1</strong> more to unlock <strong>' + nextPct + '% off</strong> the ' + ord;
              tierHintEl.hidden = false;
            } else {
              tierHintEl.hidden = true;
            }
          } else {
            var nextTier = null;
            for (var ti = 0; ti < config.tiers.length; ti++) { if (q < config.tiers[ti].min) { nextTier = config.tiers[ti]; break; } }
            if (q > 0 && nextTier) {
              var need = nextTier.min - q;
              tierHintEl.innerHTML = 'Add <strong>' + need + '</strong> more to unlock <strong>' + nextTier.pct + '% off</strong>';
              tierHintEl.hidden = false;
            } else {
              tierHintEl.hidden = true;
            }
          }
        }

        if (q > 0) { atcBtn.removeAttribute('disabled'); atcText.textContent = config.messages.atcReady + ' • ' + q + ' ' + (q===1?'item':'items'); }
        else { atcBtn.setAttribute('disabled',''); atcText.textContent = config.messages.atcChoose; }

        if (heroAtcBtn && heroAtcLabelEl) {
          // Button label stays "Add to cart" (no price, no item count, no renewal) on every viewport.
          var isDesktop = window.matchMedia('(min-width: 900px)').matches;
          if (q > 0) { heroAtcLabelEl.textContent = heroAtcOriginalLabel; }
          else if (isDesktop) { heroAtcLabelEl.textContent = config.messages.atcChoose || 'Pick your pack'; }
          if (heroRecurringEl) heroRecurringEl.hidden = true;
        }
      }

      var setQtyFns = new Map();
      products.forEach(function(p) {
        var display = p.querySelector('[data-qty-display]');
        var addBtn = p.querySelector('[data-qty-add]');
        var controls = p.querySelector('[data-qty-controls]');
        var incrBtn = p.querySelector('[data-qty-incr]');
        var decrBtn = p.querySelector('[data-qty-decr]');
        var variantSelect = p.querySelector('[data-variant-select]');
        var priceEl = p.querySelector('[data-product-price]');
        var isHero = p.dataset.isHero === 'true';

        function setQty(n) {
          n = Math.max(0, n);
          if (isHero) n = Math.max(1, n);
          var prev = parseInt(p.dataset.qty || 0, 10);
          p.dataset.qty = n;
          if (display) display.textContent = n;
          p.classList.toggle('is-selected', n > 0 && !isHero);
          if (addBtn && controls) {
            if (n > 0) { addBtn.hidden = true; controls.hidden = false; }
            else { addBtn.hidden = false; controls.hidden = true; }
          }
          if (n > prev && n > 0) { p.classList.remove('is-flash'); requestAnimationFrame(function(){ requestAnimationFrame(function(){ p.classList.add('is-flash'); }); }); }
          if (display && n !== prev) { display.classList.remove('is-pop'); requestAnimationFrame(function(){ requestAnimationFrame(function(){ display.classList.add('is-pop'); }); }); }
          recompute();
        }
        setQtyFns.set(p, setQty);
        if (addBtn) addBtn.addEventListener('click', function(){ setQty(1); });
        if (incrBtn) incrBtn.addEventListener('click', function(){ setQty(parseInt(p.dataset.qty||0,10)+1); });
        if (decrBtn) decrBtn.addEventListener('click', function(){ setQty(parseInt(p.dataset.qty||0,10)-1); });
        if (variantSelect) {
          variantSelect.addEventListener('change', function(e) {
            var opt = e.target.options[e.target.selectedIndex];
            p.dataset.variantId = opt.value;
            p.dataset.price = opt.dataset.price;
            if (priceEl) priceEl.textContent = formatMoney(parseInt(opt.dataset.price, 10));
            recompute();
            if (isHero) {
              try { cbbSwapGalleryMedia(opt.dataset.mediaId, root.dataset.section); }
              catch (err) { console.error('CBB gallery swap error', err); }
            }
          });
        }
      });

      tiers.forEach(function(tier) {
        tier.addEventListener('click', function() {
          if (!heroProduct) return;
          var min = parseInt(tier.dataset.tierMin, 10);
          if (isNaN(min) || min < 1) return;
          var fn = setQtyFns.get(heroProduct);
          if (fn) fn(min);
        });
      });

      if (packCta) {
        packCta.addEventListener('click', function() {
          var decoyTier = config.tiers[2] || config.tiers[config.tiers.length - 1];
          var heroQty = decoyTier && decoyTier.min ? decoyTier.min : 12;
          if (heroProduct) {
            var fn = setQtyFns.get(heroProduct);
            if (fn) fn(heroQty);
          }
          var picks = root.querySelectorAll('.cbb__pick:not(.cbb__pick--extra)[data-product]');
          var added = 0;
          picks.forEach(function(pp) {
            if (added >= 2) return;
            if (pp.dataset.isHero === 'true') return;
            var fn = setQtyFns.get(pp);
            if (fn) { fn(1); added++; }
          });
          packCta.classList.add('is-applied');
          if (pickSection) {
            try { pickSection.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch(e) {}
          }
        });
      }

      if (pickMoreBtn && pickSection && pickMoreText) {
        var pickMoreOriginal = pickMoreText.textContent;
        pickMoreBtn.addEventListener('click', function() {
          var expanded = pickSection.classList.toggle('is-expanded');
          pickMoreBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          pickMoreText.textContent = expanded ? 'Show less' : pickMoreOriginal;
        });
      }

      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          tabs.forEach(function(t){ t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
          state.purchaseType = tab.dataset.purchase;
          if (freqWrap) freqWrap.style.display = state.purchaseType === 'subscribe' ? '' : 'none';
          recompute();
        });
      });
      if (freqSelect) {
        freqSelect.addEventListener('change', function() {
          state.frequency = freqSelect.value;
          recompute();
        });
      }

      /* Reduce any human-written cadence phrase to a canonical "unit:count" token.
         The frequency <option> labels come from the merchant setting cbb_frequencies
         ("Month, 2 Weeks") while the plan names come from the subscription app
         ("Once a Month (Starting Today)", "Bi-Weekly"). Those two vocabularies do not
         overlap as strings, so the old substring match silently failed for biweekly
         and fell through to plans[0] (= the monthly plan). Normalising both sides
         makes the match label-independent. */
      function cadenceKey(str) {
        if (!str) return null;
        var s = String(str).toLowerCase().replace(/[‐-―]/g, '-');
        if (/bi[\s-]?weekly|fortnight/.test(s)) return 'week:2';
        if (/bi[\s-]?monthly/.test(s)) return 'month:2';
        if (/quarterly/.test(s)) return 'month:3';
        var n = s.match(/(\d+)\s*-?\s*(day|week|month)/);
        if (n) {
          var count = parseInt(n[1], 10), unit = n[2];
          if (unit === 'day') {                       /* days -> the equivalent week/month */
            if (count % 7 === 0 && count <= 28) return 'week:' + (count / 7);
            if (count === 30 || count === 31) return 'month:1';
            if (count === 60) return 'month:2';
            if (count === 90) return 'month:3';
          }
          return unit + ':' + count;
        }
        if (/weekly/.test(s)) return 'week:1';
        if (/monthly|a month|per month|every month/.test(s)) return 'month:1';
        if (/daily/.test(s)) return 'day:1';
        var u = s.match(/\b(day|week|month)s?\b/);
        if (u) return u[1] + ':1';
        return null;
      }

      function findPlanId(productId) {
        var plans = sellingPlansByProduct[productId];
        if (!plans || plans.length === 0) return null;
        if (state.frequency) {
          var want = cadenceKey(state.frequency);
          if (want) {
            var byCadence = plans.find(function(p){ return cadenceKey(p.name) === want; });
            if (byCadence) return byCadence.id;
          }
          var m = plans.find(function(p){ return p.name && p.name.toLowerCase().indexOf(state.frequency.toLowerCase()) !== -1; });
          if (m) return m.id;
          console.warn('CBB: no selling plan matches frequency "' + state.frequency + '" for product ' + productId + ' — falling back to "' + plans[0].name + '"');
        }
        return plans[0].id;
      }

      function buildItems(onlyHero) {
        var items = [];
        products.forEach(function(p) {
          if (onlyHero && p.dataset.isHero !== 'true') return;
          var qty = parseInt(p.dataset.qty||0, 10);
          if (qty < 1) return;
          var item = { id: parseInt(p.dataset.variantId, 10), quantity: qty };
          if (state.purchaseType === 'subscribe') { var pid = findPlanId(p.dataset.productId); if (pid) item.selling_plan = pid; }
          items.push(item);
        });
        return items;
      }

      function submitItems(items, btn, labelEl, restoreLabel) {
        if (items.length === 0) return;
        if (btn) btn.setAttribute('disabled', '');
        if (labelEl) labelEl.textContent = config.messages.atcAdding;
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function(r){ if (!r.ok) return r.json().then(function(err){ throw new Error(err.description || 'Cart error'); }); return r.json(); })
          .then(function(){
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            var drawer = document.querySelector('cart-drawer, [data-cart-drawer], .cart-drawer, #CartDrawer, .yv-cart-drawer');
            if (drawer) {
              drawer.classList.add('is-open', 'open', 'active');
              drawer.removeAttribute('hidden');
              document.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));
              if (btn) btn.removeAttribute('disabled');
              if (labelEl && restoreLabel) labelEl.textContent = restoreLabel;
            } else {
              window.location.href = '/cart';
            }
          })
          .catch(function(err){ console.error('CBB add error', err); showToast(err.message || 'Could not add items. Please try again.'); if (btn) btn.removeAttribute('disabled'); if (labelEl && restoreLabel) labelEl.textContent = restoreLabel; recompute(); });
      }

      atcBtn.addEventListener('click', function() {
        if (atcBtn.hasAttribute('disabled')) return;
        submitItems(buildItems(false), atcBtn, atcText, config.messages.atcReady);
      });
      if (heroAtcBtn) {
        heroAtcBtn.addEventListener('click', function() {
          var isDesktop = window.matchMedia('(min-width: 900px)').matches;
          submitItems(buildItems(!isDesktop), heroAtcBtn, null, null);
        });
      }

      recompute();

      /* PORTAL the sticky bottom bar to <body>. The buy box renders inside the theme's
         position:sticky column, and sticky elements always form a stacking context —
         so no z-index can lift a fixed child above sections that appear later in the
         page (the advertorial and cross-sell rail were painting over the bar on
         mobile). Moving the bar to <body> lets it stack at page level. The wrapper
         keeps the .cbb class plus the root's inline style so the CSS custom properties
         (bar background, borders, text colors) still resolve outside the buy box. All
         element references captured above stay valid after the move. */
      var bottomBar = root.querySelector('[data-bottom-bar]');
      if (bottomBar && !bottomBar.dataset.cbbPortaled) {
        bottomBar.dataset.cbbPortaled = '1';
        var portal = document.createElement('div');
        portal.className = 'cbb cbb--portal';
        portal.setAttribute('style', (root.getAttribute('style') || ''));
        document.body.appendChild(portal);
        portal.appendChild(bottomBar);
      }
    });
  })();

  /* Custom frequency dropdown — replaces the native <select> popup (which floated
     mis-positioned on mobile). The native select stays in the DOM as the source of
     truth: choosing a custom option sets its value + dispatches 'change', so all the
     existing subscription logic keeps working unchanged. */
  (function () {
    function buildFreq(sel) {
      if (!sel || sel._fetFreqUI) return;
      sel._fetFreqUI = true;
      var ui = document.createElement('div');
      ui.className = 'cbb__freq-ui';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cbb__freq-btn';
      btn.setAttribute('aria-haspopup', 'listbox');
      var lbl = document.createElement('span');
      function currentText() { return sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].text.trim() : ''; }
      lbl.textContent = currentText();
      btn.appendChild(lbl);
      btn.insertAdjacentHTML('beforeend', '<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M2 4l4 4 4-4" stroke="#FF5722" stroke-width="1.5" fill="none" stroke-linecap="round"/></svg>');
      var menu = document.createElement('ul');
      menu.className = 'cbb__freq-menu';
      menu.setAttribute('role', 'listbox');
      [].slice.call(sel.options).forEach(function (o, i) {
        var li = document.createElement('li');
        li.className = 'cbb__freq-opt';
        li.setAttribute('role', 'option');
        li.textContent = o.text.trim();
        if (i === sel.selectedIndex) li.classList.add('is-sel');
        li.addEventListener('click', function (e) {
          e.stopPropagation();
          sel.selectedIndex = i;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          lbl.textContent = o.text.trim();
          menu.querySelectorAll('.cbb__freq-opt').forEach(function (x) { x.classList.remove('is-sel'); });
          li.classList.add('is-sel');
          ui.classList.remove('is-open');
        });
        menu.appendChild(li);
      });
      btn.addEventListener('click', function (e) { e.stopPropagation(); ui.classList.toggle('is-open'); });
      document.addEventListener('click', function () { ui.classList.remove('is-open'); });
      // keep the button label in sync if the value changes elsewhere
      sel.addEventListener('change', function () { lbl.textContent = currentText(); });
      sel.classList.add('cbb__freq--hidden');
      sel.parentElement.insertBefore(ui, sel);
      ui.appendChild(btn);
      ui.appendChild(menu);
    }
    function init() {
      document.querySelectorAll('.cbb__freq-select').forEach(buildFreq);
    }
    if (document.readyState !== 'loading') { init(); }
    else { document.addEventListener('DOMContentLoaded', init); }
  })();

  /* Mobile-only: horizontal image-thumbnail strip under the main product image.
     The theme hides its own vertical thumb strip on mobile; we build a horizontal
     row from the same thumbnail images and tap-scroll the (native flex-scroll)
     main slider to the matching slide via the media-id pairing
     (thumb data-image="media-N"  ->  main slide id="media-main-N"). */
  (function () {
    var MOBILE = '(max-width: 768px)';

    /* Only the CURRENT variant's thumbnails should appear (the theme pre-hides the
       other variants' near-identical copies with their own display:none). We test the
       item's OWN computed display — NOT offsetParent — because on mobile the theme also
       hides the whole thumb container, which would make every item read as hidden. */
    function visibleThumbs() {
      return [].slice.call(document.querySelectorAll(
        '.yv-product-small-slider.data-thumb-slider .yv-product-slider-item[data-image]'
      )).filter(function (t) { return getComputedStyle(t).display !== 'none'; });
    }

    function buildStrip() {
      var existing = document.querySelector('.fet-mthumbs');
      if (existing) existing.remove();
      if (!window.matchMedia(MOBILE).matches) return;
      if (!document.querySelector('.cbb')) return;            // buy-box product pages only
      var main = document.querySelector('.product-detail-slider .data-main-slider');
      if (!main) return;
      var src = visibleThumbs();
      if (src.length < 2) return;                             // single image / nothing to show

      var strip = document.createElement('div');
      strip.className = 'fet-mthumbs';

      /* M&S template: micro-thumb variant of the strip (first 8 + "+N" pill) */
      var msMini = !!document.querySelector('[data-cbb].cbb--ms');
      var MS_MINI_VISIBLE = 8;
      if (msMini) strip.classList.add('fet-mthumbs--mini');

      src.forEach(function (t, idx) {
        var img = t.querySelector('img');
        var id = t.getAttribute('data-image');
        if (!img || !id) return;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'fet-mthumb' + (msMini && idx >= MS_MINI_VISIBLE ? ' fet-mthumb--extra' : '');
        btn.setAttribute('data-image', id);
        btn.setAttribute('aria-label', 'View product image');
        var im = document.createElement('img');
        im.src = img.currentSrc || img.src || img.getAttribute('data-src') || '';
        im.loading = 'lazy';
        im.alt = '';
        btn.appendChild(im);
        btn.addEventListener('click', function () {
          var num = id.replace('media-', '');
          var slide = document.getElementById('media-main-' + num) || main.querySelector('[id$="' + num + '"]');
          if (!slide) return;
          var dx = slide.getBoundingClientRect().left - main.getBoundingClientRect().left;
          main.scrollBy({ left: dx, behavior: 'smooth' });
          strip.querySelectorAll('.fet-mthumb').forEach(function (x) { x.classList.remove('is-active'); });
          btn.classList.add('is-active');
        });
        strip.appendChild(btn);
      });

      if (msMini && src.length > MS_MINI_VISIBLE) {
        var more = document.createElement('button');
        more.type = 'button';
        more.className = 'fet-mthumb-more';
        more.textContent = '+' + (src.length - MS_MINI_VISIBLE);
        more.setAttribute('aria-label', 'Show all ' + src.length + ' images');
        more.addEventListener('click', function () {
          strip.classList.add('is-expanded');
          more.remove();
        });
        strip.appendChild(more);
      }

      // place the strip directly beneath the main image
      var anchor = main.parentElement || main;
      anchor.insertAdjacentElement('afterend', strip);
    }

    var rt;
    function scheduleBuild() { clearTimeout(rt); rt = setTimeout(buildStrip, 250); }

    function init() {
      buildStrip();
      /* Rebuild when the variant changes: the theme fades/hides thumb items by
         variant-color, so re-read the now-visible set. (Does not touch that feature.) */
      var thumbWrap = document.querySelector('.yv-product-small-slider.data-thumb-slider');
      if (thumbWrap && window.MutationObserver) {
        new MutationObserver(scheduleBuild).observe(thumbWrap, {
          attributes: true, attributeFilter: ['style', 'class'], subtree: true
        });
      }
    }
    if (document.readyState !== 'loading') { init(); }
    else { document.addEventListener('DOMContentLoaded', init); }
    window.addEventListener('resize', scheduleBuild);
  })();

  /* ===== M&S variant selector (cbb_ms_selector) =====
     UI layer over the existing hidden [data-variant-select]: rows of pills (or a
     2-value toggle) for every product option except the last, cards for the last
     option. Selecting a combo sets the select's value and dispatches 'change', so
     the existing handler does pricing, recompute, selling plans and gallery swap.
     Structure comes from the product's own options, so it adapts per product:
       1 option  -> cards only
       2 options -> one row + cards
       3 options -> two rows + cards (etc.)
     Combos that don't exist as variants are simply not rendered; sold-out combos
     render as disabled cards (or dimmed row pills when a whole value is sold out),
     and a fully sold-out selection flips both ATC buttons to "Sold out". */
  (function(){
    document.querySelectorAll('[data-cbb].cbb--ms').forEach(function(root){
      var host = root.querySelector('[data-ms-selector]');
      var hero = root.querySelector('[data-is-hero="true"]');
      if (!host || !hero) return;
      var select = hero.querySelector('[data-variant-select]');
      var cfgEl = host.querySelector('[data-ms-config]');
      if (!select || !cfgEl) return;
            var cfg, subPct = 0;
      try { cfg = JSON.parse(cfgEl.textContent); } catch(e){ console.error('MS config parse error', e); return; }
      try { subPct = JSON.parse(root.querySelector('[data-cbb-config]').textContent).subPct || 0; } catch(e){}

      /* Zip the three parallel list metafields (Size / Range / Weight) into
         row objects, index-for-index. Empty when the product has no value in
         the Size metafield, which is what gates the "Size guide" link below. */
      cfg.sizeGuideRows = [];
      if (cfg.sizeGuideSizes && cfg.sizeGuideSizes.length) {
        for (var sgI = 0; sgI < cfg.sizeGuideSizes.length; sgI++) {
          cfg.sizeGuideRows.push({
            size: cfg.sizeGuideSizes[sgI] || '',
            range: (cfg.sizeGuideRanges && cfg.sizeGuideRanges[sgI]) || '',
            weight: (cfg.sizeGuideWeights && cfg.sizeGuideWeights[sgI]) || ''
          });
        }
      }

      var names = cfg.optionNames || [];
      var variants = cfg.variants || [];
      if (!variants.length || !names.length) return;

      var nDims = names.length;
      var packIdx = nDims - 1; /* last option renders as cards */

            function el(tag, cls){ var n = document.createElement(tag); if (cls) n.className = cls; return n; }
      function money(c){ return '$' + (c/100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'); }

      var sizeGuideModal = null;
      function buildSizeGuideModal(){
        if (sizeGuideModal) return sizeGuideModal;
        var overlay = el('div', 'cbb__sg-overlay');
        var modal = el('div', 'cbb__sg-modal');
        modal.setAttribute('role', 'dialog');
        modal.setAttribute('aria-modal', 'true');
        modal.setAttribute('aria-label', 'Size guide');
        var head = el('div', 'cbb__sg-head');
        var title = el('h3', 'cbb__sg-title');
        title.textContent = 'View Size Guidelines';
        var closeBtn = el('button', 'cbb__sg-close');
        closeBtn.type = 'button';
        closeBtn.setAttribute('aria-label', 'Close');
        closeBtn.innerHTML = '&times;';
        closeBtn.addEventListener('click', closeSizeGuide);
        head.appendChild(title);
        head.appendChild(closeBtn);
        modal.appendChild(head);

        var table = el('table', 'cbb__sg-table');
        var thead = el('thead');
        var trh = el('tr');
                ['Size', 'Bone length', 'Weight'].forEach(function(h){ var th = el('th'); th.textContent = h; trh.appendChild(th); });
        thead.appendChild(trh);
        table.appendChild(thead);
        var tbody = el('tbody');
                /* Smallest to largest: Medium, Large, Extra Large, Monster. Only sorts when
           every row's size name is recognised; otherwise keeps the metafield order. */
        var sgRows = cfg.sizeGuideRows.slice();
        var sgAllRanked = sgRows.every(function(r){ return rankValue(r.size) != null; });
        if (sgAllRanked) sgRows.sort(function(a, b){ return rankValue(a.size) - rankValue(b.size); });
        sgRows.forEach(function(row){
          var tr = el('tr');
          var td1 = el('td'); td1.textContent = row.size; tr.appendChild(td1);
          var td2 = el('td'); td2.textContent = row.range; tr.appendChild(td2);
          var td3 = el('td'); td3.textContent = row.weight; tr.appendChild(td3);
          tbody.appendChild(tr);
        });
        table.appendChild(tbody);
        modal.appendChild(table);

        overlay.appendChild(modal);
        overlay.addEventListener('click', function(e){ if (e.target === overlay) closeSizeGuide(); });
        document.body.appendChild(overlay);
        sizeGuideModal = overlay;
        return overlay;
      }
      function openSizeGuide(){
        var overlay = buildSizeGuideModal();
        overlay.classList.add('is-open');
        document.body.classList.add('cbb-sg-locked');
      }
      function closeSizeGuide(){
        if (sizeGuideModal) sizeGuideModal.classList.remove('is-open');
        document.body.classList.remove('cbb-sg-locked');
      }
      document.addEventListener('keydown', function(e){
        if (e.key === 'Escape' && sizeGuideModal && sizeGuideModal.classList.contains('is-open')) closeSizeGuide();
      });
      function flagParse(val){ var m = String(val).match(/^(.*?)\s*-\s*(popular|sale)\s*$/i); return m ? { label: m[1], flag: m[2].toUpperCase() } : { label: String(val), flag: null }; }
      function mode(){ var t = root.querySelector('[data-purchase].is-active'); return t ? t.dataset.purchase : 'subscribe'; }

      /* Looks up a per-variant sub-text from the "Size Variants Sub Texts" list
         metafield. Each list entry is "Variant Name: sub text" — match on the
         part before the first ":" (case-insensitive, trimmed) against the pill's
         visible label, return the part after ":" (trimmed). Returns null if the
         metafield is empty or nothing matches, so pills without a match just
         show the title with no sub text. */
      function sizeSubtextFor(label){
        var list = cfg.sizeSubTexts;
        if (!list || !list.length) return null;
        var target = String(label).trim().toLowerCase();
        for (var k = 0; k < list.length; k++){
          var entry = list[k];
          if (!entry) continue;
          var idx = entry.indexOf(':');
          if (idx === -1) continue;
          var key = entry.slice(0, idx).trim().toLowerCase();
          if (key === target) return entry.slice(idx + 1).trim();
        }
        return null;
      }

      /* Largest-to-smallest ordering (Marcell 2026-08-05). Numeric values rank by
         their number (25 pk > 5 pk, 12 Inch > 6 Inch); weight units count as bulk
         and beat pack counts (3 lbs > 5 pk); word sizes rank by the map below.
         Keys are checked in order, so longer phrases sit above their substrings
         ("extra-thick" before "thick"). A row is only sorted when EVERY value
         gets a rank — otherwise it keeps catalog order rather than half-sorting. */
      var SIZE_WORDS = [
        ['monster', 900], ['giant', 880], ['xxl', 870], ['extra large', 860], ['extra-large', 860], ['xl', 860],
        ['jumbo', 840], ['extra-thick', 830], ['extra thick', 830], ['thick', 700], ['large', 600], ['wide', 550],
        ['standard', 500], ['regular', 500], ['medium', 400], ['small', 300], ['thin', 200], ['mini', 100], ['petite', 100]
      ];
      function rankValue(raw){
        var s = flagParse(raw).label.toLowerCase().trim();
        var num = s.match(/(\d+(?:\.\d+)?)/);
        if (num) {
          var n = parseFloat(num[1]);
          if (/lb|pound|kg|kilo/.test(s)) return 100000 + n;
          return n;
        }
        for (var w = 0; w < SIZE_WORDS.length; w++) { if (s.indexOf(SIZE_WORDS[w][0]) !== -1) return SIZE_WORDS[w][1]; }
        return null;
      }
      function sortVals(vals, asc){
  var ranks = {};
  for (var i = 0; i < vals.length; i++) {
    var r = rankValue(vals[i]);
    if (r == null) return vals;
    ranks[vals[i]] = r;
  }
  return vals.slice().sort(function(a, b){ return asc ? ranks[a] - ranks[b] : ranks[b] - ranks[a]; });
}
      function valuesAt(i, pool){ var seen = [], out = []; (pool || variants).forEach(function(v){ if (seen.indexOf(v.opts[i]) === -1){ seen.push(v.opts[i]); out.push(v.opts[i]); } }); return sortVals(out, true); }
      function matchPrefix(depth){ return variants.filter(function(v){ for (var i = 0; i < depth; i++){ if (v.opts[i] !== sel[i]) return false; } return true; }); }
      function findVariant(){ return variants.filter(function(v){ return v.opts.every(function(o, i){ return o === sel[i]; }); })[0] || null; }
      function hasAvail(pool, i, val){ return pool.some(function(v){ return v.opts[i] === val && v.available; }); }
      function hasAny(pool, i, val){ return pool.some(function(v){ return v.opts[i] === val; }); }

            var current = variants.filter(function(v){ return String(v.id) === String(select.value); })[0] || variants[0];
      var sel = current.opts.slice();

      /* Default the size row (row 0) to "Large" on first load, unless the URL
         already pins a specific variant (?variant=…) — a shared/bookmarked
         link should win over this default. snapDeep(0) below will then fix
         every deeper dimension to match. */
      try {
        var urlHasVariant = /[?&]variant=/.test(window.location.search);
        if (!urlHasVariant) {
          var largeVal = valuesAt(0).filter(function(v){ return flagParse(v).label.trim().toLowerCase() === 'medium'; })[0];
          if (largeVal) sel[0] = largeVal;
        }
      } catch (e) {}

      /* After a row selection changes, make every deeper dimension valid again:
         keep the current value if it still exists (and, for the card row, is in
         stock when an in-stock sibling exists); otherwise take the first in-stock
         value, falling back to the first that exists (all-sold-out case). */
      function snapDeep(fromDim){
        for (var i = fromDim; i < nDims; i++) {
          var pool = matchPrefix(i);
          var vals = valuesAt(i, pool);
          var keep = vals.indexOf(sel[i]) !== -1 && (i < packIdx || hasAvail(pool, i, sel[i]) || !vals.some(function(v2){ return hasAvail(pool, i, v2); }));
          if (!keep) {
            var firstAvail = vals.filter(function(v2){ return hasAvail(pool, i, v2); })[0];
            sel[i] = firstAvail || vals[0];
          }
        }
      }

            function build(){
        host.innerHTML = '';
        for (var i = 0; i < packIdx; i++) (function(i){
          var vals = valuesAt(i);
          var group = el('div', 'cbb__ms-group');
                    var lab = el('div', 'cbb__ms-label');
          lab.appendChild(document.createTextNode(names[i] + ': '));
          var valSpan = el('span', 'cbb__ms-val');
          valSpan.setAttribute('data-ms-val', i);
          lab.appendChild(valSpan);
          if (i === 0 && cfg.sizeGuideRows && cfg.sizeGuideRows.length) {
            var sgBtn = el('button', 'cbb__ms-sizeguide-btn');
            sgBtn.type = 'button';
            sgBtn.innerHTML = '<svg viewBox="0 0 16 16" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="8" cy="8" r="6.5"/><line x1="8" y1="7" x2="8" y2="11.5"/><circle cx="8" cy="4.6" r="0.6" fill="currentColor" stroke="none"/></svg><span>Size guide</span>';
            sgBtn.addEventListener('click', openSizeGuide);
            lab.appendChild(sgBtn);
          }
          group.appendChild(lab);
          if (cfg.sizeDescription) {
            var descEl = el('div', 'cbb__ms-desc');
            descEl.innerHTML = cfg.sizeDescription;
            group.appendChild(descEl);
          }
          var wrap = el('div', vals.length === 2 ? 'cbb__ms-seg' : 'cbb__ms-pills');
          wrap.setAttribute('data-ms-row', i);
          vals.forEach(function(val){
          var b = el('button', 'cbb__ms-pill');
            b.type = 'button';
            b.setAttribute('data-ms-dim', i);
            b.setAttribute('data-ms-value', val);
            b.appendChild(el('span', 'cbb__ms-pill-radio'));
            var pillText = el('span', 'cbb__ms-pill-text');
            var pillLabelText = flagParse(val).label;
            var pillTitle = el('span', 'cbb__ms-pill-title');
            pillTitle.textContent = pillLabelText;
            pillText.appendChild(pillTitle);
            var pillSubText = sizeSubtextFor(pillLabelText);
            if (pillSubText) {
              var pillSub = el('span', 'cbb__ms-pill-sub');
              pillSub.textContent = pillSubText;
              pillText.appendChild(pillSub);
            }
                        b.appendChild(pillText);
            if (i === 0 && cfg.sizeBadgeText && cfg.sizeBadgeFor &&
                pillLabelText.trim().toLowerCase() === String(cfg.sizeBadgeFor).trim().toLowerCase()) {
              var sizeFlag = el('span', 'cbb__ms-pill-flag');
              sizeFlag.textContent = cfg.sizeBadgeText;
              if (cfg.badgeColors && cfg.badgeColors.popular) {
                sizeFlag.style.background = cfg.badgeColors.popular.bg;
                sizeFlag.style.color = cfg.badgeColors.popular.text;
              }
              b.appendChild(sizeFlag);
            }
            b.addEventListener('click', function(){
              if (b.classList.contains('is-unavail') || sel[i] === val) return;
              sel[i] = val;
              snapDeep(i + 1);
              apply();
            });
            wrap.appendChild(b);
          });
          group.appendChild(wrap);
          host.appendChild(group);
        })(i);
        var group = el('div', 'cbb__ms-group');
        var lab = el('div', 'cbb__ms-label');
        lab.appendChild(document.createTextNode(names[packIdx] + ': '));
        var packValSpan = el('span', 'cbb__ms-val');
        packValSpan.setAttribute('data-ms-val', 'pack');
        lab.appendChild(packValSpan);
        group.appendChild(lab);
        if (cfg.packCardSubtext) {
          var packSub = el('div', 'cbb__ms-desc');
          packSub.textContent = cfg.packCardSubtext;
          group.appendChild(packSub);
        }
        var cards = el('div', 'cbb__ms-cards');
        cards.setAttribute('data-ms-cards', '');
        group.appendChild(cards);
        host.appendChild(group);
        host.hidden = false;
      }

      function sync(){
        /* row pill states + selected-value labels */
        for (var i = 0; i < packIdx; i++) {
          var pool = matchPrefix(i);
          host.querySelectorAll('[data-ms-dim="' + i + '"]').forEach(function(b){
            var val = b.getAttribute('data-ms-value');
            b.classList.toggle('is-active', sel[i] === val);
            b.classList.toggle('is-unavail', !hasAny(pool, i, val));
            b.classList.toggle('is-soldout', hasAny(pool, i, val) && !hasAvail(pool, i, val));
          });
        var vs = host.querySelector('[data-ms-val="' + i + '"]');
          if (vs) vs.textContent = flagParse(sel[i]).label;
        }
        var packVs = host.querySelector('[data-ms-val="pack"]');
        if (packVs) packVs.textContent = flagParse(sel[packIdx]).label;
            
                /* rebuild cards for the current prefix */
        var cardsEl = host.querySelector('[data-ms-cards]');
        var pool = matchPrefix(packIdx);
        var m = mode();
        var packUnit = cfg.packUnitSingular || 'unit';

        /* Discount % to apply as "was"/SAVE across every card in this row,
           derived from whichever variant here has a real Shopify
           compare_at_price. Falls back to null (no strikethrough shown) only
           if NO variant in the row has compare_at_price set at all. */
        var poolDiscountPct = null;
        pool.forEach(function(pv){
          if (poolDiscountPct != null) return;
          if (pv.comparePrice && pv.comparePrice > pv.price) {
            var pctFound = Math.round((1 - (pv.price / pv.comparePrice)) * 100);
            if (pctFound > 0) poolDiscountPct = pctFound;
          }
        });

        cardsEl.innerHTML = '';
        valuesAt(packIdx, pool).forEach(function(val){
          var v = pool.filter(function(x){ return x.opts[packIdx] === val; })[0];
          if (!v) return;
          var parsed = flagParse(val);
          var card = el('button', 'cbb__ms-card' + (sel[packIdx] === val ? ' is-active' : '') + (v.available ? '' : ' is-soldout'));
          card.type = 'button';

          card.appendChild(el('span', 'cbb__ms-radio'));

          if (v.img) { var im = el('img', 'cbb__ms-thumb'); im.src = v.img; im.alt = ''; im.loading = 'lazy'; card.appendChild(im); }

          var ti = el('span', 'cbb__ms-ctitle'); ti.textContent = parsed.label; card.appendChild(ti);

          /* Badge: comes from the variant's own "Variant Card Badge" metafield.
             Colour is matched by keyword against the three named types set in the
             section's Pack Size Cards settings; anything else uses the accent color. */
          if (v.badge) {
            var bt = String(v.badge).trim();
            if (bt) {
              var btKey = bt.toLowerCase();
              var bc = cfg.badgeColors && (
                btKey.indexOf('try') !== -1 ? cfg.badgeColors.tryit :
                btKey.indexOf('popular') !== -1 ? cfg.badgeColors.popular :
                btKey.indexOf('value') !== -1 ? cfg.badgeColors.bestvalue : null
              );
              var badgeEl = el('span', 'cbb__ms-cbadge');
              badgeEl.textContent = bt;
              if (bc) { badgeEl.style.background = bc.bg; badgeEl.style.color = bc.text; }
              card.appendChild(badgeEl);
            }
          }

          if (!v.available) {
            var so = el('span', 'cbb__ms-flag--soldout'); so.textContent = 'SOLD OUT'; card.appendChild(so);
          }

                    var showSub = m === 'subscribe' && v.available && subPct > 0;
          var displayPrice = showSub ? Math.round(v.price * (100 - subPct) / 100) : v.price;
          var nowEl = el('span', 'cbb__ms-cnow');
          nowEl.textContent = money(displayPrice);
          card.appendChild(nowEl);

          /* "Was" price + SAVE badge. Bug fix: previously this only showed when the
             VARIANT ITSELF had a Shopify compare_at_price set, so packs without one
             (3/5/10-pack here) silently showed full price with no strikethrough —
             even though the exact same catalog sale applies to them. Fixed by using
             poolDiscountPct (computed once above, from whichever variant in this
             pack-size row DOES have a real compare_at_price) and applying that same
             percentage to every card's own displayPrice. This self-corrects: for the
             variant that already has its own compare_at_price, the derived "was"
             matches it exactly; for variants missing one, it backfills correctly. */
          if (poolDiscountPct != null) {
            var wasPrice = Math.round(displayPrice / (1 - poolDiscountPct / 100));
            if (wasPrice > displayPrice) {
              var wasEl = el('span', 'cbb__ms-cwas'); wasEl.textContent = money(wasPrice); card.appendChild(wasEl);
              var saveEl = el('span', 'cbb__ms-csave'); saveEl.textContent = 'SAVE ' + poolDiscountPct + '%'; card.appendChild(saveEl);
            }
          }

                   /* Per-unit note: pull the leading number off the pack option's own text
             ("3 Bones" -> 3, "10 Pk" -> 10) and divide the displayed price by it. */
          var qtyMatch = String(val).match(/(\d+(?:\.\d+)?)/);
          var qty = qtyMatch ? parseFloat(qtyMatch[1]) : 1;
          if (qty > 0) {
            var noteEl = el('span', 'cbb__ms-cnote');
            noteEl.textContent = money(Math.round(displayPrice / qty)) + ' per ' + packUnit;
            card.appendChild(noteEl);
          }

          

          if (v.available) {
            card.addEventListener('click', function(){
              if (sel[packIdx] === val) return;
              sel[packIdx] = val;
              apply();
            });
          }
          cardsEl.appendChild(card);
        });
        syncAtc();
      }

      function syncAtc(){
        var v = findVariant();
        var soldout = !v || !v.available;
        var heroAtc = hero.querySelector('[data-hero-atc]');
        var heroLbl = hero.querySelector('.cbb__hero-atc-label');
        var barAtc = document.querySelector('.cbb--portal [data-atc]') || root.querySelector('[data-atc]');
        if (soldout) {
          if (heroAtc) { heroAtc.setAttribute('disabled', ''); if (heroLbl) heroLbl.textContent = 'Sold out'; }
          if (barAtc) { barAtc.setAttribute('disabled', ''); var t = barAtc.querySelector('[data-atc-text]'); if (t) t.textContent = 'Sold out'; }
        } else if (heroAtc) {
          heroAtc.removeAttribute('disabled');
          /* label + bottom bar restored by the existing recompute() */
        }
      }

      function apply(force){
        var v = findVariant();
        if (!v) return;
        if (force || String(select.value) !== String(v.id)) {
          select.value = String(v.id);
          /* runs the existing handler: dataset price, recompute, gallery swap */
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        sync();
      }

      /* recompute() rewrites the ATC labels and card prices depend on the purchase
         mode, so re-sync after any control that triggers recompute. Delegated
         listeners on the root run after the buttons' own handlers. */
      root.addEventListener('click', function(e){
        if (e.target.closest && e.target.closest('[data-purchase],[data-qty-incr],[data-qty-decr]')) sync();
      });
      root.addEventListener('change', function(e){
        if (e.target.matches && e.target.matches('[data-frequency-select]')) syncAtc();
      });

      build();
      snapDeep(0);
      /* force the initial dispatch so the gallery un-hide (cbb--ms branch in
         cbbSwapGalleryMedia) also runs on page load, not only after a click */
      apply(true);
      /* the theme's own slider init runs after this script and re-hides the
         non-selected variants' slides — re-apply once it has finished */
      if (document.readyState === 'complete') { setTimeout(function(){ apply(true); }, 300); }
      else { window.addEventListener('load', function(){ setTimeout(function(){ apply(true); }, 300); }); }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fet-ugc"] && !Shopify.designMode) return;
  try {
    (function() {
  document.querySelectorAll('.ftugc').forEach(function(section) {
    var cards = section.querySelectorAll('[data-ugc-card]');

    function pauseAll(except) {
      cards.forEach(function(card) {
        if (card === except) return;
        var v = card.querySelector('[data-ugc-video]');
        if (v && !v.paused) { try { v.pause(); } catch(e){} }
        card.classList.remove('is-playing');
      });
    }

    cards.forEach(function(card) {
      var video = card.querySelector('[data-ugc-video]');
      var btn = card.querySelector('[data-ugc-toggle]');
      if (!video) return;

      function play() {
        pauseAll(card);
        video.muted = false;
        var p = video.play();
        if (p && p.catch) {
          p.catch(function(err) {
            if (err && err.name === 'AbortError') return;
            video.muted = true;
            video.play().catch(function(){});
          });
        }
        card.classList.add('is-playing');
      }
      function toggle() {
        if (!card.classList.contains('is-playing')) play();
        else { video.pause(); card.classList.remove('is-playing'); }
      }

      if (btn) btn.addEventListener('click', function(e) { e.stopPropagation(); toggle(); });
      video.addEventListener('click', toggle);
      video.addEventListener('pause', function() { card.classList.remove('is-playing'); });
      video.addEventListener('play', function() { card.classList.add('is-playing'); });
      video.addEventListener('ended', function() { card.classList.remove('is-playing'); });
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
